/* Palmekongen: bladene i logoets sol flagrer som palmevifter i vinden */
(function () {
  if (window.__pkSol) return;
  window.__pkSol = true;

  var NS = 'http://www.w3.org/2000/svg';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function hiRes(s) {
    return s.replace(/([?&](?:width|height)=)\d+/g, '$1600');
  }

  function layer(src, W, H, idxs) {
    var c = document.createElement('canvas');
    c.width = W; c.height = H;
    var g = c.getContext('2d');
    var out = g.createImageData(W, H);
    for (var i = 0; i < idxs.length; i++) {
      var p = idxs[i] * 4;
      out.data[p] = src[p]; out.data[p + 1] = src[p + 1]; out.data[p + 2] = src[p + 2]; out.data[p + 3] = src[p + 3];
    }
    g.putImageData(out, 0, 0);
    return c.toDataURL('image/png');
  }

  function make(img, b) {
    var W = b.naturalWidth, H = b.naturalHeight;
    if (!W || !H) return false;
    var c = document.createElement('canvas');
    c.width = W; c.height = H;
    var g = c.getContext('2d');
    g.drawImage(b, 0, 0);
    var d = g.getImageData(0, 0, W, H).data;
    var on = function (x, y) { return d[(y * W + x) * 4 + 3] > 8; };

    var x, y, y0 = -1;
    for (y = 0; y < H && y0 < 0; y++) for (x = 0; x < W; x++) if (on(x, y)) { y0 = y; break; }
    if (y0 < 0) return false;
    for (y = y0; y < H; y++) {
      var any = false;
      for (x = 0; x < W; x++) if (on(x, y)) { any = true; break; }
      if (!any) break;
    }
    var yb = y - 1;
    if (yb >= H - 2) return false;

    var lab = new Int32Array(W * H).fill(-1), comps = [];
    for (y = y0; y <= yb; y++) for (x = 0; x < W; x++) {
      var k = y * W + x;
      if (lab[k] >= 0 || !on(x, y)) continue;
      var id = comps.length, st = [k], px = [];
      lab[k] = id;
      while (st.length) {
        var p = st.pop(), a = p % W, bb = (p - a) / W;
        px.push(p);
        var nb = [[1, 0], [-1, 0], [0, 1], [0, -1]];
        for (var j = 0; j < 4; j++) {
          var nx = a + nb[j][0], ny = bb + nb[j][1];
          if (nx < 0 || nx >= W || ny < y0 || ny > yb) continue;
          var q = ny * W + nx;
          if (lab[q] < 0 && on(nx, ny)) { lab[q] = id; st.push(q); }
        }
      }
      comps.push(px);
    }

    var blades = [];
    for (var ci = 0; ci < comps.length; ci++) {
      var pxs = comps[ci];
      if (pxs.length < 30) continue;
      var n = pxs.length, sx = 0, sy = 0, sxx = 0, syy = 0, sxy = 0;
      for (var m = 0; m < n; m++) {
        var xx = pxs[m] % W, yy = (pxs[m] - xx) / W;
        sx += xx; sy += yy; sxx += xx * xx; syy += yy * yy; sxy += xx * yy;
      }
      var cx = sx / n, cy = sy / n;
      var t = 0.5 * Math.atan2(2 * (sxy / n - cx * cy), (sxx / n - cx * cx) - (syy / n - cy * cy));
      blades.push({ px: pxs, n: n, cx: cx, cy: cy, ux: Math.cos(t), uy: Math.sin(t) });
    }
    if (blades.length < 3) return false;

    var A = 0, B = 0, C = 0, D = 0, E = 0;
    blades.forEach(function (bl) {
      var nx = -bl.uy, ny = bl.ux, w = bl.n, kk = nx * bl.cx + ny * bl.cy;
      A += w * nx * nx; B += w * nx * ny; C += w * ny * ny; D += w * nx * kk; E += w * ny * kk;
    });
    var det = A * C - B * B;
    if (Math.abs(det) < 1e-6) return false;
    var Fx = (D * C - B * E) / det, Fy = (A * E - B * D) / det;
    if (!isFinite(Fx) || !isFinite(Fy)) return false;

    blades.sort(function (p, q) { return Math.atan2(p.cy - Fy, Fx - p.cx) - Math.atan2(q.cy - Fy, Fx - q.cx); });

    var inBlade = new Uint8Array(W * H);
    blades.forEach(function (bl) { for (var i = 0; i < bl.px.length; i++) inBlade[bl.px[i]] = 1; });
    var rest = [];
    for (var r = 0; r < W * H; r++) if (!inBlade[r] && d[r * 4 + 3] > 0) rest.push(r);

    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');

    var base = document.createElementNS(NS, 'image');
    base.setAttribute('href', layer(d, W, H, rest));
    base.setAttribute('width', W); base.setAttribute('height', H);
    svg.appendChild(base);

    blades.forEach(function (bl, i) {
      var gEl = document.createElementNS(NS, 'g');
      gEl.setAttribute('class', 'pk-blad');
      var amp = 3.2 + (i % 3) * 0.5;
      gEl.setAttribute('style', '--i:' + i + ';--a:' + amp + ';transform-origin:' + Fx.toFixed(1) + 'px ' + Fy.toFixed(1) + 'px');
      var im = document.createElementNS(NS, 'image');
      im.setAttribute('href', layer(d, W, H, bl.px));
      im.setAttribute('width', W); im.setAttribute('height', H);
      gEl.appendChild(im);
      svg.appendChild(gEl);
    });

    var wrap = document.createElement('span');
    wrap.className = 'pk-sol';
    img.parentNode.insertBefore(wrap, img);
    wrap.appendChild(img);
    wrap.appendChild(svg);
    img.classList.add('pk-sol-kilde');
    return true;
  }

  function build(img) {
    return new Promise(function (resolve) {
      if (img.dataset.pkSol) return resolve(false);
      img.dataset.pkSol = '1';
      var src = img.getAttribute('src');
      if (!src) return resolve(false);
      var b = new Image();
      b.onload = function () {
        var ok = false;
        try { ok = make(img, b); } catch (e) { ok = false; }
        resolve(ok);
      };
      b.onerror = function () { resolve(false); };
      b.src = hiRes(src);
    });
  }

  function flagre(a, soft) {
    if (!a.querySelector('.pk-sol')) return;
    a.classList.remove('pk-flagrer', 'pk-brise');
    void a.offsetWidth;
    a.classList.add(soft ? 'pk-brise' : 'pk-flagrer');
    clearTimeout(a.__pkT);
    a.__pkT = setTimeout(function () { a.classList.remove('pk-flagrer', 'pk-brise'); }, 2600);
  }

  function init() {
    var links = document.querySelectorAll('.pk-logo');
    Array.prototype.forEach.call(links, function (a) {
      var imgs = a.querySelectorAll('img.header__heading-logo');
      Promise.all(Array.prototype.map.call(imgs, build)).then(function () {
        if (reduce) return;
        a.addEventListener('mouseenter', function () { flagre(a); });
        a.addEventListener('focus', function () { flagre(a); });
        if (a.classList.contains('pk-logo--forside')) {
          var intro = document.documentElement.classList.contains('pk-logo-intro');
          setTimeout(function () { flagre(a); }, intro ? 1400 : 500);
          setInterval(function () { if (!document.hidden) flagre(a, true); }, 11000);
        }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
